
import React, { useState, useEffect, useRef } from "react";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import Lab from "./components/Lab";
import { jwtDecode } from "jwt-decode";

function App() {
  // ✅ Initialize token directly from localStorage (fixes refresh bug)
  const [token, setToken] = useState(() => {
    return localStorage.getItem("token");
  });

  const [activeLab, setActiveLab] = useState(null);

  const [score, setScore] = useState(0);
  const [completed, setCompleted] = useState(0);
  const [globalScore, setGlobalScore] = useState(0);
  const [globalCompleted, setGlobalCompleted] = useState(0);
 
  const [labProgress, setLabProgress] = useState(() => {
  try {
    const saved = localStorage.getItem("labProgress");
    return saved ? JSON.parse(saved) : {};
  } catch {
    return {};
  }
});

  const [user, setUser] = useState(() => {
    const saved = localStorage.getItem("token");
    if (!saved) return null;

    try {
      return jwtDecode(saved);
    } catch {
      localStorage.removeItem("token");
      return null;
    }
  });

  // ✅ Reset lab progress when switching labs
  
// Restore lab state when switching labs
useEffect(() => {
  if (!activeLab) return;

  const saved = labProgress[activeLab];

  setScore(saved?.score || 0);
  setCompleted(saved?.completed || 0);
}, [activeLab]);
//
useEffect(() => {
  if (!activeLab) return;

  setLabProgress((prev) => ({
    ...prev,
    [activeLab]: { score, completed }
  }));
}, [score, completed]);
//
useEffect(() => {
  localStorage.setItem("labProgress", JSON.stringify(labProgress));
}, [labProgress]);
  // ✅ Sync user whenever token changes
  useEffect(() => {
    if (!token) {
      setUser(null);
      return;
    }

    try {
      setUser(jwtDecode(token));
    } catch {
      localStorage.removeItem("token");
      setToken(null);
      setUser(null);
    }
  }, [token]);

  // ✅ Login handler
  const handleLogin = (token) => {
    localStorage.setItem("token", token);
    setToken(token);
    setUser(jwtDecode(token));
  };

  // ✅ Logout handler
/*
  const handleLogout = () => {
    localStorage.removeItem("token");
    setToken(null);
    setUser(null);
    setActiveLab(null);
    setScore(0);
    setCompleted(0);
  };
*/
const handleLogout = () => {
  // Remove stored data
  localStorage.removeItem("token");
  localStorage.removeItem("labProgress");

  // Reset authentication
  setToken(null);
  setUser(null);

  // Close active lab
  setActiveLab(null);

  // Reset current lab
  setScore(0);
  setCompleted(0);

  // Reset global totals
  setGlobalScore(0);
  setGlobalCompleted(0);

  // Clear saved progress
  setLabProgress({});
};

  return (
    <div style={{ height: "100vh", width: "100%" }}>
      {!token ? (
        <Login onLogin={handleLogin} />
      ) : !activeLab ? (
        <Dashboard
          user={user}
          onStartLab={setActiveLab}
          globalScore={globalScore}
          globalCompleted={globalCompleted}
          score={score}
          completed={completed}
          onLogout={handleLogout}
        />
      ) : (
        <Lab
          token={token}
          labId={activeLab}
          onExit={() => setActiveLab(null)}
          score={score}
          completed={completed}
          setScore={setScore}
          setCompleted={setCompleted}
          globalScore={globalScore}
          setGlobalScore={setGlobalScore}
          globalCompleted={globalCompleted}
          setGlobalCompleted={setGlobalCompleted}
        />
      )}
    </div>
  );
}

export default App;